import { connect } from 'react-redux';
import PengisianDaftarNilai from '../../../views/Kurikulum/Ulangan/PengisianDaftarNilai.view';
import { getStudent } from '../../../states/thunks/student.thunk';
import { editDaftarNilai, saveDaftarNilai, getLembarDaftarNilai } from '../../../states/thunks/academics.thunk';
import { getPeriodsOptions } from '../../../states/thunks/options.thunk';

function mapStateToProps(state) {
  return {
    user: state.user,
    result: state.result,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
    handleEditDaftarNilai: (payload, goBack) => dispatch(editDaftarNilai(payload, goBack)),
    handleSaveDaftarNilai: (payload, goback) => dispatch(saveDaftarNilai(payload, goback)),
    handleGetDaftarNilai: payload => dispatch(getLembarDaftarNilai(payload)),

    getPeriodsOptions: payload => dispatch(getPeriodsOptions(payload)),
  };
}
export default connect(mapStateToProps, mapDispatchToProps)(PengisianDaftarNilai);
